/* global $, google: false */
'use strict';

/**
 * Google Map
 */
$( document ).ready(function() {
	'use strict';

	let $map = $('.map');
	if ($map.length > 0) {
		let elMap = $map;
		elMap.googleMap( elMap.data('json') );
	}
});

/**
 * Google Map Function
 */
$.fn.googleMap = function(options) {
	let el = $(this);

	let settings = $.extend({
		'lat': '37.979561',
		'lng': '23.728487',
		'zoom': 13,
		'styles': '',
		'places_categories': false,
		'locations': [{
			lat: -33.890542,
			lng: 151.274856,
			address: '',
			tooltip: false,
			marker_svg: false,
			marker_svg_file: false,
			marker_svg_size_width: 40,
			marker_svg_size_height: 80,
			image_src: '',
			image_alt: '',
			info_title: '',
			info_text: '',
			info_btn: '',
			info_btn_url: '',
			info_btn_target: '',
		}],
	}, options);

	let markers = [];
	let bounds = new google.maps.LatLngBounds();

	let offsetHeight = $('nav.navbar').length ? $('nav.navbar').position().top : 0;
	// let offsetHeight = $('nav.navbar').height() * 2;

	let map = new google.maps.Map(el[0], {
		zoom: settings.zoom,
		zoomControl: true,
		scaleControl: false,
		scrollwheel: false,
		styles: settings.styles ? settings.styles : '',
		streetViewControl: false,
		disableDoubleClickZoom: true,
		mapTypeControl: false,
		fullscreenControl: false
	});

	$.each(settings.locations, function (i, attr) {

		let locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
		let infoButtonString = '';
		let infoImageUrl = '';
		let markerInfowindow = false;
		let icon = false;

		if (attr.info_btn_url) {
			infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
		}

		if (attr.image_src) {
			infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
		}

		if (attr.marker_svg_file) {
			icon = {
				url: attr.marker_svg_file,
				scaledSize: new google.maps.Size(attr.marker_svg_size_width, attr.marker_svg_size_height),
				anchor: new google.maps.Point(attr.marker_svg_size_width, attr.marker_svg_size_height),
			};
		}

		if (attr.info_text || attr.info_title) {
			let contentString =
				'<div class="map-infowindow">' +
				infoImageUrl +
				'<div class="main-gmap">' +
				'<h3 class="text-dark">' + attr.info_title + '</h3>' +
				'<div class="text-dark">' + attr.info_text +
				infoButtonString +
				'</div>' +
				'</div>' +
				'</div>';

			markerInfowindow = new google.maps.InfoWindow({
				content: contentString
			});
		}

		let marker = new google.maps.Marker({
			position: locLatLng,
			map: map,
			icon: icon ? icon : '',
			draggable: false,
			zIndex: -20,
			infowindow: markerInfowindow ? markerInfowindow : false,
		});

		markers.push(marker);

		marker.addListener('click', function () {
			hideAllInfoWindows(map);
			if (this.infowindow) {
				this.infowindow.open(map, this);
			}
			map.setCenter(this.getPosition());
			map.panTo(this.getPosition());

			if (offsetHeight) {
				map.panBy(0, -offsetHeight);
			}
		});

		map.panTo(marker.getPosition());

		if (offsetHeight && window.innerWidth > 768) {
			map.panBy(0, -offsetHeight);
		}

		bounds.extend(locLatLng);
	});

	map.setZoom(settings.zoom);
	if (Object.keys(settings.locations).length > 1) {
		map.fitBounds(bounds);
	}

	function hideAllInfoWindows(map) {
		markers.forEach(function (marker) {
			if (marker.infowindow) {
				marker.infowindow.close(map, marker);
			}
		});
	}
};
